var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue } from 'vue-property-decorator';
/*
Some items in the database can be soft-deleted, meaning they are not actually deleted from the database, but are marked as deleted.
This component is used to filter items based on whether they are trashed or not.
*/
let TrashedSelect = class TrashedSelect extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        this.selectItems = [
            { value: true, label: this.$tc('Show inactive items') },
            { value: false, label: this.$tc('Only show active items') },
        ];
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedTrashed = this.value;
        // #endregion
        // #region Lifecycle Hooks
        // #endregion
        // #region Event handlers
        // #endregion
        // #region Class methods
        // #endregion
        // #region Async methods (api calls only)
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    onTrashedSelected(selectedTrashed) {
        this.$emit('input', selectedTrashed);
    }
};
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TrashedSelect.prototype, "value", void 0);
TrashedSelect = __decorate([
    Component({})
], TrashedSelect);
export default TrashedSelect;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
